<template>
  <div class="pi-message">
    <div class="pi-message-opacity"
         :class="divShow? 'opacity-show' : 'opacity-hide'"></div>
    <div class="pi-message-box"
         :class="divShow? 'div-scale' : 'div-scaleHide'">
      <div class="title"
           v-if="title!=''">{{title}}</div>
      <div class="text"
           :class="{'active' : textActive}"
           v-if="text != ''">
        <div v-html="text"></div>
      </div>
      <div class="pi-message-btn">
        <div class="pi-message-flex bdr"
             :class=" !confirmActive ? 'active' : ''"
             v-if="isCancel"
             @click="cancel">{{cancelText}}</div>
        <div class="pi-message-flex"
             :class="confirmActive ? 'active':''"
             @click="confirm">{{confirmText}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pi-message',
  data () {
    return {
      title: '提示',
      cancelText: '取消',
      isCancel: true,
      confirmText: '确定',
      confirmActive: false,
      textActive: false,
      text: '',
      divShow: true
    };
  },
  methods: {
    confirm () { this.confirmFn && this.confirmFn(); },
    cancel () { this.cancelFn && this.cancelFn(); }
  },
  mounted () {

  }
};
</script>

<style lang="less" scoped>
@import "../../assets/less/old/var.less";

.pi-message {
  font-size: 0.36rem;
  line-height: 0.5rem;
  .pi-message-opacity {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(90, 91, 93, 0.5);
    z-index: 7;
  }
  .pi-message-box {
    width: 5.4rem;
    border-radius: 0.24rem;
    background-color: #fff;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    z-index: 8;
    .title {
      text-align: center;
      color: #030303;
      padding: 0 0.2rem;
      padding-top: 0.38rem;
    }
    .text {
      color: #999;
      text-align: center;
      .size;
      padding: 0.3rem 0.2rem 0.1rem 0.2rem;
    }
    .text.active {
      color: #030303;
    }
    .pi-message-btn {
      margin-top: 0.3rem;
      display: flex;
      color: #4a4a4a;
      text-align: center;
      border-top: @border;
      .pi-message-flex {
        flex: 1;
        padding: 0.2rem 0 0.16rem 0;
      }
      .pi-message-flex.bdr {
        border-right: @border;
      }
      .pi-message-flex.active {
        color: @main-color;
      }
    }
  }
}
</style>
